jQuery.feature_import("js-views-administrationorganizationusers-edit",
  () => require("./Edit.js"),
  mod => mod.feature_js_views_administrationorganizationusers_edit
);